/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteReportShareInput = {
    id: string;
    reportId: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteReportShareMutationVariables = {
    input: DeleteReportShareInput;
};
export type deleteReportShareMutationResponse = {
    readonly deleteReportShare: {
        readonly deletedShareId: string | null;
    } | null;
};
export type deleteReportShareMutation = {
    readonly response: deleteReportShareMutationResponse;
    readonly variables: deleteReportShareMutationVariables;
};



/*
mutation deleteReportShareMutation(
  $input: DeleteReportShareInput!
) {
  deleteReportShare(input: $input) {
    deletedShareId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteReportShareInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteReportSharePayload",
    "kind": "LinkedField",
    "name": "deleteReportShare",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedShareId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteReportShareMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteReportShareMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteReportShareMutation",
    "operationKind": "mutation",
    "text": "mutation deleteReportShareMutation(\n  $input: DeleteReportShareInput!\n) {\n  deleteReportShare(input: $input) {\n    deletedShareId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e9cd177ced7333a84a4ae136de8dcb2e';
export default node;
